import { render, staticRenderFns } from "./postModal.vue?vue&type=template&id=d7c3d4b8&lang=pug&"
import script from "./postModal.vue?vue&type=script&setup=true&lang=js&"
export * from "./postModal.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./postModal.vue?vue&type=style&index=0&id=d7c3d4b8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports